<template>
  <affix
    relative-element-selector="#home-section"
    :vertical="true"
    :offset="{ top: 63, bottom: 0, padding: 0 }"
    :style="myTheme.topMenu.normal"
  >
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-md-4 d-none d-sm-block"></div>
            <div class="col-lg-5 col-md-8 mx-auto" style="text-align:center">
              <n-button
              class="flat-button"
                type="primary"
                link
                @click="onButtonClicked('menu')"
                :style="[ active == 'menu' ? 
                {'color': myTheme.topMenu.active.color, 'borderBottom' : '5px solid ' + myTheme.topMenu.active.backgroundColor}  
                : 
                {'color': myTheme.topMenu.normal.color, 'borderBottom' : '5px solid ' + myTheme.topMenu.normal.backgroundColor}]"
              >
                <i class="new-ui-icons k-icon-menu"></i> {{ $t('button.menu') }}
              </n-button>
              <n-button
                class="flat-button"
                type="primary"
                link
                @click="onButtonClicked('fav')"
               :style="[ active == 'fav' ? 
                {'color': myTheme.topMenu.active.color, 'borderBottom' : '5px solid ' + myTheme.topMenu.active.backgroundColor}  
                : 
                {'color': myTheme.topMenu.normal.color, 'borderBottom' : '5px solid ' + myTheme.topMenu.normal.backgroundColor}]"
              >
                <i class="new-ui-icons k-icon-heart"></i> {{ $t('button.favourites') }}
              </n-button>
              <n-button 
                class="flat-button"
                type="primary"
                link
                @click="onButtonClicked('deals')"
                :style="[ active == 'deals' ? 
                {'color': myTheme.topMenu.active.color, 'borderBottom' : '5px solid ' + myTheme.topMenu.active.backgroundColor}  
                : 
                {'color': myTheme.topMenu.normal.color, 'borderBottom' : '5px solid ' + myTheme.topMenu.normal.backgroundColor}]"
              >
                <i class="new-ui-icons k-icon-tag"></i> {{ $t('button.deals') }}
              </n-button>
            </div>
            <div class="col-lg-4 d-none d-lg-block" ></div>
          </div>
        </div>


  </affix>
</template>

<script>
import {
  Affix,
  Button,
  FormGroupInput
} from "@/components";
import { Popover } from "element-ui";
import router from "@/router"

export default {
  name: "main-navbar",
  components: {
    [Popover.name]: Popover,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    Affix
  },
  data() {
    return {
      active: "menu",
    };
  },
 
  methods: {
    onButtonClicked(display) {
      // display Menu / Favorite / Deals
      if(display == "fav" && !this.user){

        this.noUserFavPopup();      
      }else {

        this.active = display;
        this.$emit("buttonClicked", display);
      }
    },
    noUserFavPopup(){
        let message = this.$t("message.login_to_view_favourite");
        let options = {
          html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          okText: this.$t("button.go_to_login"),
          cancelText: this.$t("button.cancel"),
          animation: "fade", // Available: "zoom", "bounce", "fade"
          type: "basic", // coming soon: 'soft', 'hard'
          backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
          customClass: "confirm" // Custom class to be injected into the parent node for the current dialog instance
        };
        this.$dialog.confirm(message, options).then(function() 
        {
          router.push({ name: 'login', query: { redirect: '/menu' } });
        }).catch(() => {});
        return;
      }
    }
};
</script>

<style scoped>
.vue-affix {
  width: 100%;
  z-index: 997;
}
</style>
